<script>
    export let compactClaim
    import Typography from '$lib/components/UI/Typography.svelte'
    import Avatar from '$lib/components/UI/Avatar.svelte'
    import Chip from '$lib/components/UI/Chip.svelte';
    import { createEventDispatcher } from 'svelte'
    import { strftime } from '$lib/utils'
    const dispatch = createEventDispatcher()
    export let selected = false
    const onclick = () => {
        dispatch('click')
    }

    let limitedMessage = (message) => {
        if (!message) return ''
        message = compactClaim?.last_message?.message
        return message.length > 30 ? message.slice(0, 25) + '...' : message
    }
    let shortDate = (dateString) => {
        if (!dateString) return ''
        let date = new Date(dateString)
        return strftime(`%d/%m/%y`, date)
        // return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear().toString().slice(2,4)}`
    }
    const patenteFormatter = i => {
        let t = i.replace(/\W*/g, '')
        if (t.length === 6) return t.slice(0, 3) + ' ' + t.slice(3, 6)
        else if (t.length === 7) return t.slice(0, 2) + ' ' + t.slice(2, 5) + ' ' + t.slice(5, 7)
        return t 
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
    class="container"
    class:finished={compactClaim?.state == 'Finalizado'}
    class:selected
    on:click={onclick}
    title={compactClaim?.asunto || '(sin asunto)'}
>
    <Avatar
        size="default"
        name={compactClaim?.iniciado_por || '?'}
        type={selected ? 'flat' : 'default'}
    />
    <div class="container-data">
        {#if compactClaim.id_siniestro}
            <p class="sinister">#{compactClaim.id_siniestro}</p>
        {/if}
        <div style="display:flex;justify-content:flex-start">
            <Typography type="button" style="margin:0;">
                {compactClaim?.asunto || '(sin asunto)'}
            </Typography>
            <!-- <Typography
            type="subtitle"
            style="margin:0;font-style:italic"
            color="gray"
            >{compactClaim?.state == 'Finalizado'
            ? 'Finalizado'
            : ''}</Typography
            > -->
        </div>
        <Chip style="border-radius: 5px; font-weight: 700; background: grey">{patenteFormatter(compactClaim.patente)}</Chip>
        <div class="container-last-message">
            <Typography type="subtitle" style="margin:0;">
                {limitedMessage(compactClaim?.last_message?.message)}
            </Typography>
            <Typography type="subtitle" style="margin:0;">
                {shortDate(compactClaim?.last_message?.modified_date)}
            </Typography
            >
        </div>
        <!-- <Typography type="subtitle" style="margin:0;"
            >Iniciado {shortDate(compactClaim?.creation_date)}</Typography
        > -->
    </div>
</div>

<style>
    .container {
        position: relative;
        height: 5.3rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem;
        border-bottom: 1px solid #c0c0c0;
        cursor: pointer;
    }
    .container:hover {
        /* box-shadow: 0px 1px 0px 1px #c0c0c0; */
    }
    .container-data {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .container-last-message {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .finished {
        opacity: 0.5;
    }
    .selected {
        background-color: var(--color-brand-primary-01);
        opacity: 1;
        color: white;
    }
    .selected p.sinister{
        background: linear-gradient(to left,  var(--color-brand-primary-01) 0%, var(--color-brand-primary-01) 70%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        color: white;
    }
    
    .sinister {
        top: -3px;
        right: 0;
        font-weight: 700;
        padding: 0px 15px 2px 55px;
        color:var(--color-brand-primary-01);
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+100 */
        background: linear-gradient(to left,  rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        /* background: red; */
        position: absolute;
    }
</style>
